<template>
  <div>
    <v-dialog v-model="manage_limit_dialog" width="500">
      <v-card>
        <v-card-title class="text-h6 grey lighten-2"> Manage Plan Limits </v-card-title>

        <v-card-text>
          <div style="padding: 20px">
            <p><strong>Current Plan: </strong>{{ shop_plans.package_name }}</p>
            <v-text-field
              type="number"
              name="product_upload_limit"
              v-model="shop_plans.product_upload_limit"
              class="w-full"
              label="Product Upload Limit (Feed)"
              outlined
              hide-details
              v-validate="'required'"
            ></v-text-field>
            <span class="red--text text-sm" v-if="errors.has('product_upload_limit')">{{
              errors.first("product_upload_limit")
            }}</span>

            <v-text-field
              type="number"
              v-model="shop_plans.shopify_upload_limit"
              class="w-full mt-5"
              label="Shopify Upload Limit"
              outlined
              hide-details
              v-validate="'required'"
              name="shopify_upload_limit"
            ></v-text-field>
            <span class="red--text text-sm" v-if="errors.has('shopify_upload_limit')">{{
              errors.first("shopify_upload_limit")
            }}</span>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="manage_limit_dialog = false"> CANCEL </v-btn>
          <v-btn color="primary" text @click="manageShopPlanLimits"> DONE </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="extend_trial_dialog" width="500">
      <v-card>
        <v-card-title class="text-h6 grey lighten-2"> Extend Trial Days </v-card-title>

        <v-card-text>
          <div style="padding: 20px">
            <v-text-field
              type="number"
              v-model="free_trial.trial_days"
              class="w-full"
              label="Trial Days"
              outlined
            ></v-text-field>
            <div style="margin-top: -20px !important">
              <small style="color: red"
                >NOTE: It will add the above entered days in existing trial days.</small
              >
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="extend_trial_dialog = false"> CANCEL </v-btn>
          <v-btn color="primary" text @click="processTrialExtend" :loading="is_trail_button_clicked" :disabled="is_trail_button_clicked">
            <v-progress-circular v-if="is_trail_button_clicked" indeterminate color="primary" size="20"></v-progress-circular>
            <span v-else>Done</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="full_sync_shop_dialog" width="500">
      <v-card>
        <v-card-title class="text-h6 grey lighten-2"> Full Sync Shop Products</v-card-title>
        <v-card-body class="ml-5">Are you sure you want to full sync shop products?</v-card-body>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="full_sync_shop_dialog = false"> No </v-btn>
          <v-btn color="primary" text @click="fullSyncShop" :loading="is_trail_button_clicked" :disabled="is_trail_button_clicked">
            <v-progress-circular v-if="is_trail_button_clicked" indeterminate color="primary" size="20"></v-progress-circular>
            <span v-else>Yes</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="full_sync_inventory_dialog" width="500">
      <v-card>
        <v-card-title class="text-h6 grey lighten-2"> Full Sync Inventory</v-card-title>
        <v-card-body class="ml-5">Are you sure you want to full sync inventory?</v-card-body>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="full_sync_inventory_dialog = false"> No </v-btn>
          <v-btn color="primary" text @click="fullSyncInventory" :loading="is_trail_button_clicked" :disabled="is_trail_button_clicked">
            <v-progress-circular v-if="is_trail_button_clicked" indeterminate color="primary" size="20"></v-progress-circular>
            <span v-else>Yes</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

     <v-dialog v-model="full_sync_shop_collection_dialog" width="500">
      <v-card>
        <v-card-title class="text-h6 grey lighten-2"> Full Sync Shop Collection</v-card-title>
        <v-card-body class="ml-5">Are you sure you want to full sync shop?</v-card-body>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="full_sync_shop_collection_dialog = false"> No </v-btn>
          <v-btn color="primary" text @click="fullSyncShopCollection" :loading="is_trail_button_clicked" :disabled="is_trail_button_clicked">
            <v-progress-circular v-if="is_trail_button_clicked" indeterminate color="primary" size="20"></v-progress-circular>
            <span v-else>Yes</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Order Sync Toggle Confirmation Modal -->
    <v-dialog v-model="order_sync_dialog" width="500" @click:outside="cancelOrderSyncToggle">
      <v-card>
        <v-card-title class="text-h6 grey lighten-2">
          {{ shop.is_order_sync_enabled ? 'Enable' : 'Disable' }} Order Sync
        </v-card-title>
        <v-card-text class="pt-4">
          <p>Are you sure you want to {{ shop.is_order_sync_enabled ? 'enable' : 'disable' }} order synchronization?</p>
          <p class="caption">This will {{ shop.is_order_sync_enabled ? 'start' : 'stop' }} syncing orders between Shopify and your system.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="cancelOrderSyncToggle">Cancel</v-btn>
          <v-btn
            color="primary"
            text
            @click="confirmToggleOrderSync"
            :loading="is_order_sync_loading"
            :disabled="is_order_sync_loading"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Order Fetch Toggle Confirmation Modal -->
    <v-dialog v-model="order_fetch_dialog" width="500" v-if="shop.etsy_shop">
      <v-card>
        <v-card-title class="text-h6 grey lighten-2">
          {{ shop.etsy_shop.disabled_order_fetch ? 'Enable' : 'Disable' }} Order Fetch
        </v-card-title>
        <v-card-text class="pt-4">
          <p>Are you sure you want to {{ shop.etsy_shop.disabled_order_fetch ? 'enable' : 'disable' }} order fetch?</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="cancelOrderFetchToggle">Cancel</v-btn>
          <v-btn
            color="primary"
            text
            @click="toggleOrderFetch"
            :loading="is_order_fetch_loading"
            :disabled="is_order_fetch_loading"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Image Upload Jobs Response Dialog -->
    <v-dialog v-model="imageJobsDialog" max-width="700px" scrollable>
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Image Upload Jobs Dispatch Result
          <v-spacer></v-spacer>
          <v-btn icon @click="imageJobsDialog = false">
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <div v-if="imageJobsResponse">
            <v-alert
              :type="imageJobsResponse.success ? 'success' : 'error'"
              class="mb-4"
              outlined
            >
              <strong>{{ imageJobsResponse.message }}</strong>
            </v-alert>

            <v-row class="mb-2">
              <v-col cols="6">
                <strong>Total Products:</strong> {{ imageJobsResponse.total_products || 0 }}
              </v-col>
              <v-col cols="6">
                <strong>Jobs Dispatched:</strong>
                <v-chip small :color="imageJobsResponse.jobs_dispatched > 0 ? 'success' : 'error'" text-color="white" class="ml-2">
                  {{ imageJobsResponse.jobs_dispatched || 0 }}
                </v-chip>
              </v-col>
            </v-row>

            <v-row class="mb-2" v-if="imageJobsResponse.failed_dispatches > 0">
              <v-col cols="6">
                <strong>Failed Dispatches:</strong>
                <v-chip small color="error" text-color="white" class="ml-2">
                  {{ imageJobsResponse.failed_dispatches }}
                </v-chip>
              </v-col>
            </v-row>

            <v-row class="mb-2">
              <v-col cols="6">
                <strong>Queue Name:</strong> {{ imageJobsResponse.queue_name || 'N/A' }}
              </v-col>
              <v-col cols="6">
                <strong>Triggered By:</strong> {{ imageJobsResponse.triggered_by || 'N/A' }}
              </v-col>
            </v-row>

            <v-row class="mb-2">
              <v-col cols="6">
                <strong>Chunk Size Used:</strong> {{ imageJobsResponse.chunk_size_used || 'N/A' }}
              </v-col>
              <v-col cols="6">
                <strong>Memory Used:</strong> {{ imageJobsResponse.memory_used_mb ? `${imageJobsResponse.memory_used_mb.toFixed(2)} MB` : 'N/A' }}
              </v-col>
            </v-row>

            <div v-if="imageJobsResponse.errors && imageJobsResponse.errors.length > 0" class="mt-4">
              <h4 class="mb-2">Errors:</h4>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Listing ID</th>
                      <th>Error</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(error, index) in imageJobsResponse.errors" :key="index">
                      <td>{{ error.listing_id }}</td>
                      <td class="error--text">{{ error.error }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>

            <div v-if="imageJobsResponse.suggestion" class="mt-4">
              <v-alert type="info" outlined>
                <strong>Suggestion:</strong> {{ imageJobsResponse.suggestion }}
              </v-alert>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="imageJobsDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Associate Custom Plans Dialog -->
    <v-dialog v-model="associate_plan_dialog" max-width="700px" scrollable>
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Associate Custom Plans
          <v-spacer></v-spacer>
          <v-btn icon @click="associate_plan_dialog = false">
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-select
            v-model="selected_plan_ids"
            :items="available_plans"
            item-text="name"
            item-value="id"
            label="Select Plans"
            outlined
            dense
            multiple
            chips
            :loading="loading_plans"
            hint="You can select multiple plans. Limits will be merged (maximum values used)."
            persistent-hint
            :disabled="loading_plans"
            :no-data-text="loading_plans ? 'Loading plans...' : 'No plans available'"
          >
            <template v-slot:item="{ item, on, attrs }">
              <v-list-item
                class="plan-select-item"
                v-bind="attrs"
                v-on="on"
              >
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium mb-1">{{ item.name }}</v-list-item-title>
                  <v-list-item-subtitle class="d-flex align-center">
                    <span class="caption grey--text">
                      {{ item.price ? `${item.currency_code || 'USD'} ${item.price}` : 'Free' }}
                    </span>
                    <v-chip x-small color="info" text-color="white" class="ml-2" v-if="item.badge">
                      {{ item.badge }}
                    </v-chip>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:selection="{ item, index }">
              <v-chip
                v-if="index < 2"
                small
                color="primary"
                text-color="white"
                class="mr-1 mb-1"
              >
                {{ item.name }}
              </v-chip>
              <span
                v-else-if="index === 2"
                class="grey--text caption"
              >
                (+{{ selected_plan_ids.length - 2 }} more)
              </span>
            </template>
          </v-select>
          <v-alert type="info" dense outlined class="mt-3">
            <strong>Note:</strong> Multiple plans can be associated. Limits will be merged using maximum values from all plans.
          </v-alert>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="associate_plan_dialog = false">Cancel</v-btn>
          <v-btn color="primary" @click="associatePlans" :loading="isAssociatingPlan" :disabled="!selected_plan_ids || selected_plan_ids.length === 0">
            Associate {{ selected_plan_ids && selected_plan_ids.length > 0 ? `(${selected_plan_ids.length})` : '' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Remove Plans Confirmation Dialog -->
    <v-dialog v-model="remove_plan_dialog" max-width="500px">
      <v-card>
        <v-card-title class="headline error--text">
          <v-icon color="error" class="mr-2">{{ icons.mdiAlertCircle }}</v-icon>
          Remove Custom Plans
        </v-card-title>
        <v-card-text>
          <p>Are you sure you want to remove all custom plans from this shop?</p>
          <v-alert type="info" dense outlined class="mt-3">
            The shop will revert to its default plan settings.
          </v-alert>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="remove_plan_dialog = false">Cancel</v-btn>
          <v-btn color="error" @click="removePlans" :loading="isRemovingPlan">Remove All</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Cancel Subscription Confirmation Modal -->
    <v-dialog v-model="cancel_subscription_dialog" max-width="450" persistent>
      <v-card>
        <v-card-title class="text-h5 error--text">
          <v-icon color="error" class="mr-2">{{ icons.mdiAlertCircle }}</v-icon>
          Cancel Subscription
        </v-card-title>

        <v-card-text class="pt-4">
          <p class="subtitle-1">Are you sure you want to cancel this subscription?</p>
          <v-alert
            dense
            outlined
            type="warning"
            class="mt-3"
          >
            This action cannot be undone. The shop will immediately lose access to all paid features.
          </v-alert>

          <div class="mt-4 pa-2 grey lighten-4 rounded">
            <p class="mb-1"><strong>Shop:</strong> {{ shop.specifier }}</p>
            <p class="mb-1"><strong>Plan:</strong> ${{ shop.subscribed_plan }}</p>
            <p class="mb-0"><strong>Recurring Charge ID:</strong> {{ shop.recurring_charge_id }}</p>
          </div>

          <v-divider class="my-4"></v-divider>

          <p class="subtitle-1 font-weight-bold">Type "CONFIRM" to proceed with cancellation:</p>
          <v-text-field
            v-model="confirmationText"
            outlined
            dense
            placeholder="Type CONFIRM here"
            hint="Case sensitive - must be exactly CONFIRM"
            persistent-hint
            class="mt-2"
          ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="grey darken-1"
            @click="cancel_subscription_dialog = false"
            :disabled="isCancellingSubscription"
          >
            Keep Subscription
          </v-btn>
          <v-btn
            color="error"
            @click="processSubscriptionCancellation"
            :loading="isCancellingSubscription"
            :disabled="isCancellingSubscription || confirmationText !== 'CONFIRM'"
          >
            <v-icon left>{{ icons.mdiCloseCircle }}</v-icon>
            Cancel Subscription
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div v-if="is_loading" class="text-center">
      <img
        :src="require('@/assets/images/misc/loading.gif')"
        alt=""
        width="100px"
        style="margin-top: 30vh !important"
      />
    </div>
    <v-container v-else>
      <v-row>
        <v-spacer></v-spacer>
         <v-btn
          color="success"
          :loading="is_reverse_sync_loading"
          @click="reverseSync(shop.id)"
          class="tet-white mr-2"
          small
          >Reverse Sync</v-btn
        >
        <v-btn
          color="info"
          @click="full_sync_shop_dialog = true"
          class="tet-white mr-2"
          small
          >Full Sync Shop Products</v-btn
        >

        <v-btn
          color="info"
          @click="full_sync_shop_collection_dialog = true"
          class="tet-white mr-2"
          small
          >Full Sync Shop Collection</v-btn
        >

        <!-- more button -->
        <v-menu offset-y z-index="1000">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on" small>
              <v-icon left small>{{ icons.mdiMenu }}</v-icon>
              Other Actions
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="dispatchImageUploadJobs">
              <v-icon left small>{{ icons.mdiSync }}</v-icon>
              <v-list-item-title>Sync Images (Shopify → Etsy)</v-list-item-title>
            </v-list-item>
            <v-list-item @click="manage_limit_dialog = true">
              <v-icon left small>{{ icons.mdiStopCircleOutline }}</v-icon>
              <v-list-item-title>Manage Limits</v-list-item-title>
            </v-list-item>
            <v-list-item @click="extend_trial_dialog = true">
              <v-icon left small>{{ icons.mdiClock }}</v-icon>
              <v-list-item-title>Extend Trial</v-list-item-title>
            </v-list-item>
            <v-list-item @click="full_sync_inventory_dialog = true">
              <v-icon left small>{{ icons.mdiSync }}</v-icon>
              <v-list-item-title>Full Sync Inventory</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>


      </v-row>
      <v-divider class="mt-8 mb-5"></v-divider>
      <v-row>
        <v-col>
          <v-row class="match-height">
            <v-col cols="12" sm="3">
              <!-- align icons -->
              <statistics-card-vertical
                color="green"
                :statistics="`${counts.shopify_products}`"
                stat-title="Total Shopify Products"
                subtitle="Total products in Shopify"
                :icon="icons.mdiCart"
              ></statistics-card-vertical>
            </v-col>

            <v-col cols="12" sm="3">
              <statistics-card-vertical
                color="primary"
                :statistics="`${counts.feeds}`"
                stat-title="Total Profiles Created"
                subtitle="All profiles created by user."
                :icon="icons.mdiCart"
              ></statistics-card-vertical>
            </v-col>

            <v-col cols="12" sm="3">
              <statistics-card-vertical
                color="green"
                :statistics="`${counts.uploaded_products}`"
                stat-title="Uploaded Products"
                subtitle="Uploaded/Linked products."
                :icon="icons.mdiCheck"
              ></statistics-card-vertical>
            </v-col>

            <v-col cols="12" sm="3">
              <statistics-card-vertical
                color="red"
                :statistics="`${counts.upload_failed_products}`"
                stat-title="Upload Failed Products"
                subtitle="Product upload/update failed."
                :icon="icons.mdiAlert"
              ></statistics-card-vertical>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-divider class="mt-5 mb-5"></v-divider>
      <!-- Syncing Status Cards -->
       <v-row>
        <v-col cols="12" sm="3">
          <v-card>
            <v-card-title>Products Sync</v-card-title>
            <v-card-text>
              <!-- need in two rows  -->
              <div class="mb-2">
              <v-chip
                small
                :color="getShopSyncColor('product')"
                text-color="white"
              >
                {{ getShopSyncStatus('product') }}
              </v-chip>
              </div>
              <div>
                <span class="text-xs text--secondary">
                  Last Synced: {{ getLastSyncedAt('product') }}
                </span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="3">
          <v-card>
            <v-card-title>Collections Sync</v-card-title>
            <v-card-text>
              <div class="mb-2">
              <v-chip
                small
                :color="getShopSyncColor('collection')"
                text-color="white"
              >
                {{ getShopSyncStatus('collection') }}
              </v-chip>
              </div>
              <div>
                <span class="text-xs text--secondary">
                  Last Synced: {{ getLastSyncedAt('collection') }}
                </span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="3">
          <v-card>
            <v-card-title>Metafields Sync</v-card-title>
            <v-card-text>
              <div class="mb-2">
              <v-chip
                small
                :color="getShopSyncColor('metafield')"
                text-color="white"
              >
                {{ getShopSyncStatus('metafield') }}
              </v-chip>
              </div>
              <div>
                <span class="text-xs text--secondary">
                  Last Synced: {{ getLastSyncedAt('metafield') }}
                </span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="3">
          <v-card>
            <v-card-title>Bulk Query</v-card-title>
            <v-card-text>
              <div class="mb-2">
              <v-chip
                small
                :color="getBulkQueryColor()"
                text-color="white"
              >
                {{ getBulkQueryStatus() }}
              </v-chip>
              </div>
              <div>
                <span class="text-xs text--secondary">
                  Coming Soon...
                </span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="3">
          <v-checkbox
                class="mt-0"
                v-model="shop.is_store_optimized"
                label="Store Optimized"
                color="primary"
                @click="storeOptimized()"
                hide-details>
            </v-checkbox>
        </v-col>
        <v-col cols="12" sm="3">
          <v-checkbox
                v-if="shop.etsy_shop"
                class="mt-0"
                v-model="shop.etsy_shop.disabled_order_fetch"
                label="Disable Order Fetch"
                color="primary"
                @click.prevent="showOrderFetchConfirmation"
                :loading="is_order_fetch_loading"
                :disabled="is_order_fetch_loading"
                hide-details>
          </v-checkbox>
        </v-col>
        <v-col cols="12" sm="2">
          <v-select
            aria-readonly="true"
            v-model="shop.review.app_rating"
            :items="ratingOptions"
            label="Select App Rating"
            color="primary"
            hide-details
            dense
            @change="handleRatingChange"
          ></v-select>
      </v-col>
      <v-col cols="12" sm="3">
        <v-rating
          v-model="shop.review.app_rating"
          background-color="orange"
          color="#f5bc42"
          dense
        ></v-rating>
    </v-col>

  </v-row>

      <v-row>
        <!-- If Shop has User or is not uninstalled -->
        <v-col cols="12" sm="4" v-if="shop.user !== null">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2"
              ><v-img
                max-height="30"
                max-width="30"
                :src="require('@/assets/images/avatars/1.png')"
              ></v-img>
              &nbsp;User Details</v-card-title
            >
            <v-divider></v-divider>
            <v-card-text v-if="shop.user">
              <p class="font-18">
                <strong>Name: </strong>{{ shop.user.name }} ({{ shop.user.id }})
              </p>
              <p class="font-18"><strong>Username: </strong>{{ shop.user.username }}</p>
              <p class="font-18"><strong>Email: </strong>{{ shop.user.email }}</p>
              <p class="font-18">
                <strong>Shopify Cus. Id: </strong>{{ shop.user.shopify_customer_id }}
              </p>
              <p class="font-18">
                <strong>Registered Date: </strong
                >{{ shop.user.registerDate | date_format }}
              </p>
              <p class="font-18">
                <strong>Last Visit: </strong
                >{{ shop.user.lastvisitDate | date_format("timeago") }}
              </p>
            </v-card-text>
            <v-card-text v-else>
              <div style="padding: 105px 0px" class="text-center">
                <h3>User details not found!!</h3>
              </div>
            </v-card-text>
          </v-card>

          <v-card style="margin-top: 40px;">
            <v-card-title class="text-h5 grey lighten-2">Rating/Review </v-card-title>
            <v-divider></v-divider>
            <v-card-text v-if="shop.review && !shop.review.noReview">
              <p class="font-18">
                <strong>Internal Rating: </strong>{{ shop.review.internal_rating == 0 ? "Cancelled" : shop.review.internal_rating}}
              </p>
              <p class="font-18"><strong>Internal Review: </strong>{{ shop.review.internal_review ? shop.review.internal_review : '' }}</p>
              <div style="display: flex;">
              <p class="font-18"><strong>App Rating: </strong></p>
                <v-rating
                  v-model="shop.review.app_rating"
                  background-color="orange"
                  color="#f5bc42"
                  dense
                ></v-rating>
              </div>

              <!-- Order Sync Toggle -->
              <div style="display: flex; align-items: center; margin-top: 16px;">
                <p class="font-18 mb-0 mr-4"><strong>Order Sync: </strong></p>
                <v-switch
                  v-model="shop.is_order_sync_enabled"
                  color="primary"
                  hide-details
                  @click.prevent="order_sync_dialog = true"
                  :loading="is_order_sync_loading"
                  :disabled="is_order_sync_loading"
                ></v-switch>
              </div>
            </v-card-text>
            <v-card-text v-else>
              <div style="padding: 105px 0px" class="text-center">
                <h3>No Review added yet!!</h3>
              </div>
            </v-card-text>
          </v-card>

        </v-col>
            <!-- If Shop has been uninstalled -->
          <v-col cols="12" sm="4" v-if="shop.user == null && uninstalled_client !== null">
            <v-card>
              <v-card-title class="text-h5 grey lighten-2"
                ><v-img
                  max-height="30"
                  max-width="30"
                  :src="require('@/assets/images/avatars/2.png')"
                ></v-img>
                &nbsp;Uninstalled Shop Details</v-card-title
              >
              <v-divider></v-divider>
              <v-card-text v-if="uninstalled_client">
                <p class="font-18"><strong>Shop Name: </strong>{{ uninstalled_client.shop_name }}</p>
                <p class="font-18"><strong>Email: </strong>{{ uninstalled_client.shop_email }}</p>
                <p class="font-18">
                  <strong>Total Product on Feed: </strong>{{ uninstalled_client.total_product_on_feed }}
                </p>
                  <p class="font-18">
                  <strong>Total Uploaded Products: </strong>{{ uninstalled_client.total_uploaded_products }}
                </p>
                  <p class="font-18">
                  <strong>Failed Products: </strong>{{ uninstalled_client.failed_products }}
                </p>
                <p class="font-18">
                  <strong>Total Orders: </strong>{{ uninstalled_client.total_orders }}
                </p>
                <p class="font-18">
                  <strong>Success Orders: </strong>{{ uninstalled_client.success_orders }}
                </p>
                <p class="font-18">
                  <strong>Failed Orders: </strong>{{ uninstalled_client.failed_orders }}
                </p>

              </v-card-text>
              <v-card-text v-else>
                <div style="padding: 105px 0px" class="text-center">
                  <h3>Uninstalled Client not found!!</h3>
                </div>
              </v-card-text>
            </v-card>
        </v-col>

        <v-col cols="12" sm="4">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2"
              ><v-img
                max-height="30"
                max-width="30"
                :src="require('@/assets/images/logos/shopify.png')"
              ></v-img>
              &nbsp;Shopify Shop Details</v-card-title
            >
            <v-divider></v-divider>
            <v-card-text>
              <p class="font-18"><strong>Specifier: </strong>{{ shop.specifier }}</p>
              <p class="font-18"><strong>License Key: </strong>{{ shop.license_key }}</p>
              <p class="font-18"><strong>Token: </strong>{{ shop.token }} <v-icon @click="copyToClipboard(shop.token)">{{icons.mdiContentCopy}}</v-icon></p>
              <p class="font-18">
                <strong>Last Refreshed: </strong
                >{{ shop.last_feed_refresh == null ? 'NULL' : shop.last_feed_refresh }}
              </p>
              <p class="font-18">
                <strong>Package: </strong>{{ shop_plans.package_name }} ({{
                  shop.subscribed_package
                }})
              </p>

              <div v-if="shop.license_key.includes('Free')">
                <p class="font-18">
                  <strong>Is Free?: </strong> Yes
                </p>
              </div>

              <!-- Trial Condition starts Here -->
              <!-- Billing Activate 1 =  Trial, and 2 = after trail process -->
              <div v-if="shop.license_key.includes('Trial') && !shop.license_key.includes('Ext')">
                <p class="font-18">
                  <strong>Is Trial?: </strong> Yes
                </p>
                  <p class="font-18">
                  <strong>Trial Ends On: </strong> {{shop.trial_ends_on}}
                </p>
                <p class="font-18">
                  <!-- <strong>Trial Remaining Days: </strong> {{trialDaysRemaining()}} -->
                </p>

                <!--  Trial Extended Conditions-->
              </div>

               <div v-if="shop.license_key.includes('Ext')">
                <p class="font-18">
                  <strong>Is Trial Extended?: </strong> Yes
                </p>
                  <p class="font-18">
                  <strong>Trial Ends On: </strong> {{shop.trial_ends_on}}
                </p>
                  <p class="font-18">
                  <strong>Trial Remaining Days: </strong> {{remaining_trial_days}}
                </p>
              </div>

                <p class="font-18" v-if="!shop.license_key.includes('Ext') && !shop.license_key.includes('Trial')">
                  <strong>Is Trial?: </strong> No
                </p>
                <p class="font-18" v-if="shop.trail_extended_days != 0">
                  <strong>Days Extended (Not Accepted): </strong> {{shop.trail_extended_days}}
                </p>

              <!-- Trial Condition ends Here -->

              <p class="font-18">
                <strong>Recurring Charge: </strong>${{ shop.subscribed_plan }}
              </p>

              <p class="font-18" v-if="shop.recurring_charge_id">
                <strong>Recurring Charge ID: </strong>{{ shop.recurring_charge_id }}
                <v-btn
                  v-if="shop.recurring_charge_id && shop.state > 0"
                  color="error"
                  small
                  class="ml-2"
                  @click="confirmCancelSubscription"
                  :loading="isCancellingSubscription"
                >
                  Cancel Subscription
                </v-btn>
              </p>
              <p class="font-18" v-else>
                <strong>Subscription Status: </strong>
                <v-chip small color="warning" text-color="white">No Active Subscription</v-chip>
              </p>

              <p class="font-18">
                <strong>Version: </strong>
                {{ shop.shopify_version }}
              </p>

              <p class="font-18">
                <strong>Currency: </strong>{{ shop.currency }}
              </p>

              <!-- Custom Plans Section -->
              <v-divider class="my-3"></v-divider>
              <div class="d-flex align-center justify-space-between mb-2">
                <p class="font-18 mb-0"><strong>Custom Plans: </strong></p>
                <v-chip
                  small
                  :color="shop.custom_plans && shop.custom_plans.length > 0 ? 'success' : 'warning'"
                  text-color="warning"
                >
                  {{ shop.custom_plans && shop.custom_plans.length > 0 ? `${shop.custom_plans.length} Plan(s)` : 'Not Assigned' }}
                </v-chip>
              </div>
              <div v-if="shop.custom_plans && shop.custom_plans.length > 0">
                <v-list dense>
                  <v-list-item v-for="(plan, index) in shop.custom_plans" :key="plan.id" class="px-0">
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">{{ plan.name }}</v-list-item-title>
                      <v-list-item-subtitle>
                        <span v-if="plan.price">{{ plan.currency_code || 'USD' }} {{ plan.price }}</span>
                        <span v-else class="grey--text">Free</span>
                        <v-chip x-small color="info" text-color="white" class="ml-2" v-if="plan.badge">
                          {{ plan.badge }}
                        </v-chip>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-btn
                  color="error"
                  small
                  class="mt-2"
                  @click="confirmRemovePlans"
                  :loading="isRemovingPlan"
                >
                  <v-icon left small>{{ icons.mdiClose }}</v-icon>
                  Remove All Plans
                </v-btn>
              </div>
              <div class="mt-2">
                <v-btn
                  color="primary"
                  small
                  @click="openAssociatePlanDialog"
                >
                  <v-icon left small>{{ icons.mdiPlus }}</v-icon>
                  {{ shop.custom_plans && shop.custom_plans.length > 0 ? 'Add More Plans' : 'Associate Plans' }}
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="4">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              <v-img
                max-height="35"
                max-width="35"
                :src="require('@/assets/images/logos/etsy.png')"
              ></v-img>
              &nbsp;Etsy Shop Details
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text v-if="shop.etsy_shop">
              <p class="font-18"><strong>Name: </strong>{{ shop.etsy_shop.name }}</p>
              <p class="font-18 d-flex align-center">
                <strong>Token Revoked: </strong>
                <v-chip
                  small
                  class="ml-2"
                  :color="shop.etsy_shop.is_token_revoked ? 'error' : 'success'"
                  text-color="white"
                >
                  <v-icon left small>{{ shop.etsy_shop.is_token_revoked ? icons.mdiLockOff : icons.mdiLockCheck }}</v-icon>
                  {{ shop.etsy_shop.is_token_revoked ? 'Revoked' : 'Not Revoked' }}
                </v-chip>
              </p>
              <p class="font-18">
                <strong>Shop Owner: </strong>{{ shop.etsy_shop.shop_owner }}
              </p>
              <p class="font-18">
                <strong>Shop ID: </strong>{{ shop.etsy_shop.etsy_shop_id }}
              </p>
              <p class="font-18">
                <strong>Oauth Token: </strong>{{ shop.etsy_shop.oauth_token }}
              </p>
              <p class="font-18">
                <strong>Oauth Secret: </strong>{{ shop.etsy_shop.oauth_token_secret }}
              </p>
              <p class="font-18">
                <strong>Version: </strong>{{ shop.etsy_shop.oauth_refresh_token ? 'v3' : 'v2' }}
              </p>
              <p class="font-18">
                <strong>Currency: </strong>{{ shop.etsy_shop.currency }}
              </p>
            </v-card-text>

            <v-card-text v-else>
              <div style="padding: 105px 0px" class="text-center">
                <h3>Etsy Shop not Connected!!</h3>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
.font-18 {
  font-size: 18px;
}

// Custom spacing for plan select items
::v-deep .plan-select-item {
  padding: 16px 16px !important;
  margin-bottom: 8px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
  min-height: 72px !important;
  cursor: pointer !important;
  pointer-events: auto !important;

  &:last-child {
    border-bottom: none !important;
    margin-bottom: 0 !important;
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.04) !important;
  }

  &.v-list-item--active {
    background-color: rgba(25, 118, 210, 0.12) !important;
  }

  .v-list-item__content {
    padding: 0 !important;
    pointer-events: none !important;
  }

  .v-list-item__title {
    margin-bottom: 8px !important;
    font-size: 15px !important;
  }

  .v-list-item__subtitle {
    margin-top: 4px !important;
  }
}

// Increase spacing in v-select menu
::v-deep .v-select-list {
  .v-list {
    padding: 8px 0 !important;
  }

  .v-list-item {
    margin-bottom: 8px !important;

    &:last-child {
      margin-bottom: 0 !important;
    }
  }
}
</style>
<script>
import { mapActions } from "vuex";
import { mdiCart, mdiFaceProfile, mdiCheck, mdiAlert, mdiContentCopy, mdiAlertCircle, mdiCloseCircle, mdiLockCheck, mdiLockOff, mdiSync, mdiClose, mdiMenu, mdiClock, mdiStopCircleOutline, mdiPlus  } from "@mdi/js";
import StatisticsCardVertical from "@/components/statistics-card/StatisticsCardVertical.vue";
export default {
  name: "ShopDetail",
  data() {
    return {
      is_loading: false,
      is_reverse_sync_loading: false,
      is_trail_button_clicked: false,
      is_order_sync_loading: false,
      is_order_fetch_loading: false,
      order_sync_dialog: false,
      order_fetch_dialog: false,
      shop_id: null,
      selectedRating: 0,
      confirmationText: "",
      shop: {
        is_store_optimized: false,
        is_order_sync_enabled: false,
        etsy_shop: {},
        shopify_sync_shop: {
          product_processing: false,
          collection_processing: false,
          metafield_processing: false,
          product_processed_at: null,
          collection_processed_at: null,
          _processed_at: null,
        },
        review : {
          app_rating: 0,
          internal_rating: 0,
          internal_review: "",
        }
      },
      ratingOptions: [
      { value: 0, text: 'No App Rating' },
      { value: 1, text: '1 Star' },
      { value: 2, text: '2 Stars' },
      { value: 3, text: '3 Stars' },
      { value: 4, text: '4 Stars' },
      { value: 5, text: '5 Stars' }
    ],
      uninstalled_client: {},
      icons: {
        mdiFaceProfile: mdiFaceProfile,
        mdiCart: mdiCart,
        mdiCheck: mdiCheck,
        mdiAlert: mdiAlert,
        mdiContentCopy: mdiContentCopy,
        mdiAlertCircle: mdiAlertCircle,
        mdiCloseCircle: mdiCloseCircle,
        mdiLockCheck: mdiLockCheck,
        mdiLockOff: mdiLockOff,
        mdiStopCircleOutline: mdiStopCircleOutline,
        mdiSync: mdiSync,
        mdiClose: mdiClose,
        mdiMenu: mdiMenu,
        mdiClock: mdiClock,
        mdiPlus: mdiPlus,
      },
      counts: {},
      extend_trial_dialog: false,
      full_sync_shop_dialog: false,
      full_sync_inventory_dialog: false,
      full_sync_shop_collection_dialog: false,
      free_trial: {
        trial_days: "",
        apply_plan_limit: false,
      },

      //LIMITS
      manage_limit_dialog: false,
      shop_plans: {},
      remaining_trial_days: 0,
      cancel_subscription_dialog: false,
      isCancellingSubscription: false,
      dispatchingImageJobs: false,
      imageJobsDialog: false,
      imageJobsResponse: null,
      associate_plan_dialog: false,
      remove_plan_dialog: false,
      selected_plan_ids: [],
      available_plans: [],
      loading_plans: false,
      isAssociatingPlan: false,
      isRemovingPlan: false,
    };
  },
  mounted() {
    this.shop_id = this.$route.params.shop_id;
    this.fetchShopDetail();
  },
  components: {
    StatisticsCardVertical,
  },
  methods: {
    ...mapActions(["LoginAsClient"]),
    async fetchShopDetail() {
      try {
        this.is_loading = true;
        let response = await axios.get(`admin/shops/${this.shop_id}/get-detail`);
        if (response.data.success) {
          this.shop = response.data.shop;
          if (response.data.shop.review == null) {
            this.shop.review = {
              app_rating: 0,
              internal_rating: 0,
              internal_review: "",
              noReview: true
            };
          }
          this.shop.shopify_sync_shop = response.data.shop.shopify_sync_shop;
          this.uninstalled_client= response.data.uninstalled_client;
          this.counts = response.data.counts;
          this.shop_plans = JSON.parse(response.data.shop.plan_limits);
          this.trialDaysRemaining();
        }
      } catch (e) {
      } finally {
        this.is_loading = false;
      }
    },

    async loginAsClient() {
      let resposne = await this.LoginAsClient(this.shop);
      if (resposne.success != true) {
        this.showSwalErrorToastMessage("Error", "Email or password mismatch!");
      } else {
        window.location = "/dashboard";
      }
    },

    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
      this.showSwalToastMessage("DONE", "Token copied to clipboard!");
    },

    getShopSyncStatus(type) {
      const syncShop = this.shop.shopify_sync_shop;
      if (type === 'product') {
        return syncShop?.product_processing ? 'Syncing' : 'Not Fetching  ';
      } else if (type === 'collection') {
        return syncShop?.collection_processing ? 'Syncing' : 'Not Fetching';
      } else if (type === 'metafield') {
        return syncShop?.metafield_processing ? 'Syncing' : 'Not Fetching';
      }
      return 'N/A';
    },

    getShopSyncColor(type) {
      const syncShop = this.shop.shopify_sync_shop;
      if (type === 'product') {
        return syncShop?.product_processing ? 'success' : 'info';
      } else if (type === 'collection') {
        return syncShop?.collection_processing ? 'success' : 'info';
      } else if (type === 'metafield') {
        return syncShop?.metafield_processing ? 'success' : 'info';
      }
      return 'grey';
    },

    getLastSyncedAt(type) {
      const syncShop = this.shop.shopify_sync_shop;
      console.log("syncShop", syncShop);
      if (type === 'product') {
        return syncShop?.product_processed_at ? syncShop.product_processed_at : 'N/A';
      } else if (type === 'collection') {
        return syncShop?.collection_processed_at ? syncShop.collection_processed_at : 'N/A';
      } else if (type === 'metafield') {
        return syncShop?._processed_at ? syncShop._processed_at : 'N/A';
      }
      return 'N/A';
    },

    getBulkQueryStatus() {
      const syncShop = this.shop.shopify_sync_shop;
      return syncShop?.is_bulk_query_in_progress ? 'Running' : 'No bulk query running';
    },

    getBulkQueryColor() {
      const syncShop = this.shop.shopify_sync_shop;
      return syncShop?.is_bulk_query_in_progress ? 'success' : 'info';
    },


    async trialDaysRemaining() {
        const start = new Date(new Date().toISOString().substr(0, 10));
        const end = new Date(this.shop.trial_ends_on);
        const timeDifference = end.getTime() - start.getTime();
        const daysDifference = Math.floor(timeDifference / (1000 * 3600 * 24));
        this.remaining_trial_days = daysDifference
    },

    async processTrialExtend() {
      try {
        this.is_trail_button_clicked = true;

        if (!this.free_trial.trial_days) {
          this.showSwalErrorToastMessage("Error", "Please Enter Trial Days");
          return;
        }
        let response = await axios.post(
          `admin/shops/${this.shop_id}/extend-trial`,
          this.free_trial
        );
        if (response.data.success) {
          this.showSwalToastMessage("DONE", `Trial extended for ${this.free_trial.trial_days} days. <br> <br> The Trial days of the shop is automatically extended in Shopify.`);

          this.free_trial.trial_days = "";
          this.extend_trial_dialog = false;
          this.is_trail_button_clicked = false;
          this.fetchShopDetail();
        }
      } catch (e) {
        this.showSwalErrorToastMessage("Error", "Failed to extend trial! " + e.message);
      }
    },

    async reverseSync(shop_id)
    {
      try{
        this.is_reverse_sync_loading = true;
        let response = await axios.get(
            `/set-reverse-sync-queue?shop_id=${shop_id}`
          );

          if (response.status == 200) {
            this.showSwalToastMessage("DONE", "Reverse Sync Successful! We are fetching Etsy Products Now!");
          }
          else{
            this.is_reverse_sync_loading = false;
            this.showSwalErrorToastMessage("Error", "Failed to start Reverse Sync Process! " + response.data.message);
          }
      } catch (e) {
        this.showSwalErrorToastMessage("Error", "Failed to start Reverse Sync Process! " + e.message);
      } finally {
        this.is_reverse_sync_loading = false;
      }
    },

     async fullSyncShop() {
      try {
        let response = await axios.get(`/shop/${this.shop_id}/fullsync/product`);
        if(response.data.success){
            this.full_sync_shop_dialog=false;
            this.showSwalToastMessage("DONE", "Shop products successfully added for Full Sync");
          this.fetchShopDetail();
        }
        else{
          this.showSwalErrorToastMessage("Error", "Shop products could not be Full synced!");
        }
      } catch (e) {
        this.showSwalErrorToastMessage("Error", "Failed to start Full Sync! " + e.message);
      }
    },

    async fullSyncInventory() {
      try {
        let response = await axios.get(`/admin/shop/${this.shop_id}/inventory-full-sync`);

        if(response.data.success){
            this.full_sync_inventory_dialog=false;
            this.showSwalToastMessage("DONE", "Inventory successfully added for Full Sync");
          this.fetchShopDetail();
        }
        else{
          this.showSwalErrorToastMessage("Error", "Inventory could not be Full synced!");
        }
      } catch (e) {
        this.showSwalErrorToastMessage("Error", "Failed to start Full Inventory Sync! " + e.message);
      }
    },

    async fullSyncShopCollection() {
      try {
        let response = await axios.get(`/shop/${this.shop_id}/fullsync/collection`);
        if(response.data.success){
            this.full_sync_shop_collection_dialog=false;
            this.showSwalToastMessage("DONE", "Shop collection successfully added for Full Sync");
          this.fetchShopDetail();
        }
        else{
          this.showSwalErrorToastMessage("Error", "Shop collection could not be Full synced!");
        }
      } catch (e) {
        this.showSwalErrorToastMessage("Error", "Failed to start Full Sync Collection! " + e.message);
      }
    },

    async storeOptimized(){
      let response = await axios.get(`admin/shops/${this.shop_id}/optimize-shop`);
      if (response.data.success) {
          this.showSwalToastMessage("DONE", "Optimized status changed Successfully!");
      }
      else{
        this.showSwalErrorToastMessage("Error", "Failed to change optimized status! " + response.data.message);
      }
    },

    async handleRatingChange() {
      try {
        const newRating = this.shop.review.app_rating;
        const formData = {
          app_rating: newRating,
        };

        const response = await axios.post(`admin/shops/${this.shop_id}/update-rating`, (formData));
        if (!response.data.success) {
          this.showSwalErrorToastMessage("Error", "Failed to update rating! " + response.data.message);
          return;
        }

        this.showSwalToastMessage("DONE", "Rating Updated Successfully!");
        this.fetchShopDetail();
      } catch (error) {
        console.error('Error updating rating:', error);
      }
    },

    async manageShopPlanLimits() {
      let result = await this.$validator.validateAll();
      if (!result) {
        return;
      }

      try {
        let response = await axios.post(
          `admin/shops/${this.shop_id}/manage-shop-plans`,
          this.shop_plans
        );
        if (response.data.success) {
          this.showSwalToastMessage("DONE", "Plan limit successfully updated");

          this.manage_limit_dialog = false;
          this.fetchShopDetail();
        }
      } catch (e) {
        this.showSwalErrorToastMessage("Error", "Failed to update plan limit! " + e.message);
      }
    },

    async confirmToggleOrderSync() {
      try {
        this.is_order_sync_loading = true;
        const response = await axios.post('setting/toggle-order-fetch');

        if (response.data.success) {
          this.shop.is_order_sync_enabled = !this.shop.is_order_sync_enabled;
          this.showSwalToastMessage("DONE", `Order sync has been ${this.shop.is_order_sync_enabled ? 'enabled' : 'disabled'} successfully!`);
        } else {
          throw new Error(response.data.message || 'Failed to toggle order sync');
        }
      } catch (error) {
        this.shop.is_order_sync_enabled = !this.shop.is_order_sync_enabled;
        this.showSwalErrorToastMessage("Error", "Failed to toggle order sync! " + error.message);
      } finally {
        this.is_order_sync_loading = false;
        this.order_sync_dialog = false;
      }
    },

    cancelOrderSyncToggle() {
      this.shop.is_order_sync_enabled = !this.shop.is_order_sync_enabled;
      this.order_sync_dialog = false;
    },

    showOrderFetchConfirmation() {
      // Don't toggle state yet, just show the modal
      this.order_fetch_dialog = true;
    },

    showSwalToastMessage(title, text){
      this.$swal.fire({
        toast: true,
        position: "bottom-end",
        timer: 3000,
        showConfirmButton: false,
        icon: "success",
        title: title,
        html: text,
      });
    },

    showSwalErrorToastMessage(title, text){
      this.$swal.fire({
        toast: true,
        position: "bottom-end",
        timer: 3000,
        showConfirmButton: false,
        icon: "error",
        title: title,
        html: text,
      });
    },

    cancelOrderFetchToggle() {
      this.order_fetch_dialog = false;
    },

    async toggleOrderFetch() {
      try {
        this.is_order_fetch_loading = true;
        const response = await axios.post(`admin/shops/${this.shop_id}/toggle-order-fetch`);

        if (response.data.success) {
        window.location.reload();
          // Toggle the state only after API success
          this.shop.etsy_shop.disabled_order_fetch = !this.shop.etsy_shop.disabled_order_fetch;
          this.order_fetch_dialog = false;
        } else {
          throw new Error(response.data.message || 'Failed to toggle order fetch');
        }
      } catch (error) {
        this.showSwalErrorToastMessage("Error", "Failed to toggle order fetch! " + error.message);
        this.order_fetch_dialog = false;
      } finally {
        this.is_order_fetch_loading = false;
      }
    },

    async confirmCancelSubscription() {
      this.cancel_subscription_dialog = true;
    },

    async processSubscriptionCancellation() {
      try {
        this.isCancellingSubscription = true;
        const response = await axios.post(`admin/shops/${this.shop_id}/cancel-subscription`);

        if (response.data.success || response.status === 200) {
          this.showSwalToastMessage("Success", "Subscription cancelled successfully");

          // Update local state
          this.shop.recurring_charge_id = null;
          this.shop.subscribed_plan = null;
          this.shop.state = 0;

          // Close dialog
          this.cancel_subscription_dialog = false;

          // Reset confirmation text
          this.confirmationText = "";

          // Reload page after a short delay
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          throw new Error(response.data.message || 'Failed to cancel subscription');
        }
      } catch (error) {
        console.error('Error cancelling subscription:', error);
        this.showSwalErrorToastMessage(
          "Error",
          `Failed to cancel subscription: ${error.message || 'Unknown error occurred'}`
        );
        this.cancel_subscription_dialog = false;
        this.confirmationText = "";
      } finally {
        this.isCancellingSubscription = false;
      }
    },

    async dispatchImageUploadJobs() {
      try {
        this.dispatchingImageJobs = true
        this.imageJobsResponse = null

        const response = await axios.post(`/admin/shops/${this.shop_id}/dispatch-image-upload-jobs`, {
          chunk_size: 100, // Default chunk size
        })

        this.imageJobsResponse = response.data
        this.imageJobsDialog = true

        // Show success/error message
        if (response.data.success) {
          if (response.data.failed_dispatches > 0) {
            this.showSwalToastMessage(
              "Partial Success",
              `Dispatched ${response.data.jobs_dispatched} out of ${response.data.total_products} jobs. ${response.data.failed_dispatches} jobs failed.`
            )
          } else {
            this.showSwalToastMessage(
              "Success",
              `Successfully dispatched ${response.data.jobs_dispatched} image upload jobs`
            )
          }
        } else {
          this.showSwalErrorToastMessage(
            "Error",
            response.data.message || 'Failed to dispatch image upload jobs'
          )
        }
      } catch (error) {
        console.error('Error dispatching image upload jobs:', error)
        this.imageJobsResponse = {
          success: false,
          message: error.response?.data?.message || 'Failed to dispatch image upload jobs',
          errors: error.response?.data?.errors || null,
          error_type: error.response?.data?.error_type || null,
          suggestion: error.response?.data?.suggestion || null,
        }
        this.imageJobsDialog = true

        this.showSwalErrorToastMessage(
          "Error",
          error.response?.data?.message || 'Failed to dispatch image upload jobs'
        )
      } finally {
        this.dispatchingImageJobs = false
      }
    },
    async openAssociatePlanDialog() {
      this.associate_plan_dialog = true
      this.selected_plan_ids = []
      this.loading_plans = true
      try {
        const response = await axios.get('/admin/plans')
        if (response.data && response.data.success) {
          const data = response.data.data
          // Handle both paginated and non-paginated responses
          if (Array.isArray(data)) {
            this.available_plans = data
          } else if (data.data && Array.isArray(data.data)) {
            this.available_plans = data.data
          } else {
            this.available_plans = []
          }
          // Pre-select already associated plans
          if (this.shop.custom_plans && this.shop.custom_plans.length > 0) {
            this.selected_plan_ids = this.shop.custom_plans.map(p => p.id)
          }
        } else {
          this.available_plans = []
        }
      } catch (error) {
        console.error('Error fetching plans:', error)
        this.showSwalErrorToastMessage('Error', 'Failed to load plans: ' + (error.response?.data?.message || error.message))
        this.available_plans = []
      } finally {
        this.loading_plans = false
      }
    },
    async associatePlans() {
      if (!this.selected_plan_ids || this.selected_plan_ids.length === 0) return
      try {
        this.isAssociatingPlan = true
        const response = await axios.post(`/admin/shops/${this.shop_id}/associate-plans`, {
          plan_ids: this.selected_plan_ids
        })
        if (response.data && response.data.success) {
          this.showSwalToastMessage('Success', `Successfully associated ${this.selected_plan_ids.length} plan(s)`)
          this.associate_plan_dialog = false
          this.selected_plan_ids = []
          this.fetchShopDetail()
        } else {
          throw new Error(response.data?.message || 'Failed to associate plans')
        }
      } catch (error) {
        console.error('Error associating plans:', error)
        const errorMsg = error.response?.data?.message || error.message || 'Failed to associate plans'
        this.showSwalErrorToastMessage('Error', errorMsg)
      } finally {
        this.isAssociatingPlan = false
      }
    },
    confirmRemovePlans() {
      this.remove_plan_dialog = true
    },
    async removePlans() {
      try {
        this.isRemovingPlan = true
        const response = await axios.post(`/admin/shops/${this.shop_id}/remove-plans`)
        if (response.data && response.data.success) {
          this.showSwalToastMessage('Success', 'All plans removed successfully')
          this.remove_plan_dialog = false
          this.fetchShopDetail()
        } else {
          throw new Error(response.data?.message || 'Failed to remove plans')
        }
      } catch (error) {
        console.error('Error removing plans:', error)
        const errorMsg = error.response?.data?.message || error.message || 'Failed to remove plans'
        this.showSwalErrorToastMessage('Error', errorMsg)
      } finally {
        this.isRemovingPlan = false
      }
    },
  },
};
</script>
